import { GoogleMap } from '@react-google-maps/api';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';


const mapState = atom<GoogleMap | null>({
    key: 'mapSettings',
    default: null,
});


export function useMap() {
    const map = useRecoilValue(mapState);
    const setMap = useSetRecoilState(mapState);

    return { map, setMap };
};
